module.exports = __webpack_public_path__ + "img/balkon07.229d31a8.jpg";